import { Box,Button,useMediaQuery,useTheme,MenuItem,InputLabel,FormControl } from "@mui/material";
import Select from '@mui/material/Select';
import { DataGrid, esES, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useAuth from "../../../../auth/useAuth";
import Header from "../../../../components/Header";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { actionsByRolListRoute, addActionToRolRoute, allActionsRoute, deleteActionRolRoute} from "../../../../config";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";
import DeleteIcon from '@mui/icons-material/Delete';
import { tokens } from "../../../../theme";
import { useEffect, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import swal from "sweetalert";
import * as yup from "yup";
import { Formik } from "formik"

const ActionsRoles = ({permissionsListData}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode)
  const auth = useAuth();
  const token = auth.globals.token
  const isNonMobile = useMediaQuery("(min-width:600px)")

  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const _id = query.get('id')
  const _name = query.get('name')

  
  const [ loadingRequest, setLoadingRequest ] = useState(false)
  const [ errorRequest, setErrorRequest ] = useState(null)


  const [reloadData, setReloadData] = useState(false);
  const handleReloadData = () => {
    setReloadData(true);
  };

  useEffect(() => {
    // Llama a la función para recargar datos cuando reloadData cambie a true
    if (reloadData) {
      handleReloadData();
      setReloadData(false);
      setInicitalValues({
        id_role: _id,
        id_action: "",
        create_user: auth.globals.id.toString()
      })
    }
  }, [reloadData,auth.globals.id,_id]);

  const { data: actionRolesListData, loading: actionRolesListLoading, error: actionRolesListError } = useFetchGET(_id!=null?actionsByRolListRoute(_id):undefined,token,[],reloadData);
  //console.log(actionRolesListData)

  const { data: actionsListData, loading: actionsListLoading, error: actionsListError } = useFetchGET(allActionsRoute(), token, [],reloadData);
  //console.log('Listado de todas las acciones: ',actionsListData)

  const filterActionsList = () => {
    // Crear un conjunto (Set) de IDs de actionRolesListData para búsquedas eficientes
    const actionRolesIds = new Set(actionRolesListData.map(actionRole => actionRole.id));
  
    // Filtrar actionsListData para excluir aquellos que están en actionRolesIds
    return actionsListData.filter(action => !actionRolesIds.has(action.id));
  }

  const filteredActionsList = filterActionsList();

  const navigate = useNavigate();

  const deleteActionRol = async(id_role,id_action) =>{
    //console.log('bpdy',body)
    try{
      //setLoadingRequest(true)
      let res = await fetch(deleteActionRolRoute(id_role,id_action), {
        method: "DELETE",
        headers: {
          //"Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Accept":"application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(
          {
          "id_role": id_role.toString(),
          "id_action": id_action.toString()
          }),
        //cors: 'no-cors'
      })
      let data = await res.json()
      //console.log(res)
      if(res.ok){ 
        setReloadData(true);             
      }else{
        //console.log('res else',res)
        if(res.status === 401||res.status === 403){
          mostrarErrorRequest("No tiene autorización o su sesión ha expirado")          
        }
        mostrarErrorRequest(data.detail)
        setErrorRequest(data.detail)    
      }
      setLoadingRequest(false) 
      return data;
    }catch(errorRequest){
      //console.log('errorRequest',errorRequest)
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
    }
  }

  
  const mostrarErrorRequest=(error)=>{
    if(error!=null){
      try{
        swal({
          title:"Error",
          text: "Resultado: "+error,
          icon: "error",
          button:"Aceptar"
        })
        if(error==="No tiene autorización o su sesión ha expirado"){
          auth.logout();
        }
      }catch(e){
        swal({
          title:"Error",
          text: "Error inesperado ",
          icon: "error",
          button:"Aceptar"
        })
      }
    }
    setErrorRequest(null)
  }

  const alertSucess=(text_title,text_content='')=>{    
    try{
      swal({
        title:text_title,
        text: text_content,
        icon: "success",
        button:"Aceptar"
      })
    }catch(e){
      swal({
        title:"Error inesperado",
        text: "Error inesperado ",
        icon: "error",
        button:"Aceptar"
      })
    }
    navigate("/Roles/Acciones?id="+_id+"&name="+_name)
  }

  const newActionToRol = async(body) =>{
    //console.log('bpdy',body)
    try{
      
      let res = await fetch(addActionToRolRoute(), {
        method: "POST",
        headers: {
          //"Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Accept":"application/json",
          "Authorization": `Bearer ${token}`
          //"x-access-token": token,
        },
        body: JSON.stringify(body),
        //cors: 'no-cors'
      })
      let data = await res.json()
      //console.log(res)
      if(res.ok){
        setLoadingRequest(false)
        alertSucess('Permiso agregado',data.message)
        navigate("/Roles/Acciones?id="+_id+"&name="+_name)
        setReloadData(true);       
      }else{
        //console.log('res else',res)
        if(res.status === 401||res.status === 403){
          mostrarErrorRequest("No tiene autorización o su sesión ha expirado")          
        }
        mostrarErrorRequest(data.detail)
        setErrorRequest(data.detail)    
      }
      setLoadingRequest(false) 
      return data;
    }catch(errorRequest){
      //console.log('errorRequest',errorRequest)
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
    }
  }

  const [initialValues,setInicitalValues] = useState({
    id_role: _id,
    id_action: "",
    create_user: auth.globals.id.toString()
  })

  const userSchema = yup.object().shape({
    id_action: yup.string().required("* Valor Requerido"),
  })


  const handleFormSubmit = (values) => {
    //console.log('values',values)
    setInicitalValues(values)
    setLoadingRequest(true)
    newActionToRol(values)
    //console.log('Nueva bodega')
  }

  const handleChangeAction = (values,target) =>{
    values[target.name]=target.value.toString();
  }


  const columns=[
    {
      field:"id", 
      headerName: "ID",
      cellClassName: "id-column--cell",
      headerClassName: "id-header--cell",
      hideable:false
    },
    {
      //hide: true,
      field:"name", 
      headerName: "Nombre",
      flex: 0.5, 
      cellClassName: "name-column--cell",
      minWidth:120
    },
    permissionsListData.includes(50) &&{
      minWidth:200,
      filterable:false,
      sortable:false,
      field:"actions", 
      headerName: "Acciones",
      headerAlign:"center",
      cellClassName: "actions-column--cell",
      renderCell:({ row: { id,id_role} })=>{
        return(
          <Box
            width="80%"
            maxWidth="175px"
            height="75%"
            maxHeight="35px" 
            display="flex" 
            justifyContent="center" 
            m="0 auto">
            <Button
              color="error"
              variant="contained"
              onClick={()=>{deleteActionRol(id_role,id)}}>
            <DeleteIcon/>
              <Box sx={{ml:"5px"}}>
                Eliminar Permiso
              </Box>
            </Button>
          </Box>
        )
      }
    }
  ].filter(Boolean)

  if(actionRolesListLoading||loadingRequest||actionsListLoading)
  return (<Loading/>)

  if(actionRolesListError||errorRequest||actionsListError)
  return(<FatalError/>)

  return (
    <Box p={1} >
      {/*<Box display="flex" justifyContent="space-between" alignItems="center">*/}
      {_id!=null?<Header title={'Permisos del Rol '+_name} subtitle="Listado de Permisos Asignados"/>:undefined}
      {permissionsListData.includes(49) && 
      <Formik
        enableReinitialize={true}
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema = {userSchema}
      >
      {({
        values, 
        errors, 
        touched, 
        handleBlur, 
        handleChange,
        handleSubmit,
        setFieldValue
      }) => (
        <form onSubmit={handleSubmit} >
          <Box
            display="grid" 
            gap="15px"
            marginBottom="15px" 
            gridTemplateColumns="repeat(12, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile? undefined : "span 12"}
            }}
          >        
          {<FormControl variant="filled"
            sx={{ gridColumn: "span 12"}}
            required>
            <InputLabel id="select-action-label" name="select-action-label">Permiso</InputLabel>
            <Select
              labelId="select-action-label"
              id="select-action"
              fullWidth={!isNonMobile}
              onBlur = {handleBlur}
              onChange = {(e) => {
                handleChangeAction(values,e.target);
                setFieldValue("id_action", e.target.value);
              }}
              value = {values.id_action}
              name = "id_action"
              size="small"
            >
              {/*{storesListData.map((store) => (*/}
              {filteredActionsList.map((action) => (
                <MenuItem key={action.id} value={action.id.toString()}>
                  {action.name}
                </MenuItem>
              ))}
            </Select>                  
          </FormControl>}
          </Box>
              <Box display="flex" justifyContent="end" mt="20px">               
                <Button type="submit" color="secondary" variant="contained">
                  <AddIcon/>
                    Agregar permiso
                </Button>                           
              </Box>
        </form>
        )}
      </Formik>}
      <Box m="5px 0px 50px 0" /*height={isNonMobile?"100%":undefined}*/ sx={{
        "& .MuiDataGrid-root":{
          border: "none",
        },
        "& .MuiDataGrid-cell":{
          borderBottom: "none"
        },
        "& .MuiDataGrid-columnHeaders":{
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
          color: "white"
        },
        "& .MuiDataGrid-virtualScroller":{
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer":{
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text":{
          color: `${colors.grey[100]} !important`,
        },
        "& .MuiToolbar-gutters":{
          color: "white"
        }

      }}>
        <DataGrid
          autoHeight
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns status and traderName, the other columns will remain visible
                id: false,
                actions:true
              },
            },
          }}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          rows={actionRolesListData}
          columns={columns}
          getRowId={(row) => row.id}
          density="compact"
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </Box>
    </Box>
  );


}

export default ActionsRoles;